import React from 'react';
import { Table, PagingQuery, TableAddon } from 'tea-component';
import CustomTable from '../CustomTable';
const { scrollable } = Table.addons;

interface TopchartTableProps {
  loading: boolean;
  records: any[];
  columns: any[];
  // addons?:any;
  tableTotal: number;
  pageIndex: number;
  pageSize: number;
  pageSizeOptions?: number[];
  onPagingChange: (e: PagingQuery) => void;
  className?: string;
  recordKey?: string;
  scrollMaxHeight?: string;
  nodataDom?: React.ReactNode; // 无数据展示自定义
  tableAddons?: TableAddon[];
}
export default function TopchartTable(props: TopchartTableProps) {
  const {
    loading,
    records = [],
    columns,
    // addons,
    tableTotal,
    pageIndex,
    pageSize,
    // pageSizeOptions = [20, 50, 100],
    pageSizeOptions = [10, 20, 30, 50, 100, 200],
    onPagingChange,
    className,
    recordKey,
    scrollMaxHeight,
    nodataDom,
    tableAddons,
  } = props;
  const loadingOrNodata = loading || !records?.length;
  // console.debug('TopchartTable props', props)
  return (
    <CustomTable
      loading={loading}
      recordKey={recordKey || 'app_id'}
      className={`dbi-mobileGames-table dbi-table-sticky ${className}`}
      records={Array.isArray(records) ? records : []}
      columns={columns}
      tableTotal={tableTotal}
      pageIndex={pageIndex}
      pageSize={pageSize}
      nodataDom={nodataDom}
      pageSizeOptions={pageSizeOptions}
      onPagingChange={onPagingChange}
      tableAddons={[
        ...(tableAddons || []),
        scrollable({
          minWidth: 'auto',
          maxHeight: scrollMaxHeight ? scrollMaxHeight : '100%',
          minHeight: loadingOrNodata ? '158px' : 'auto',
        }),
      ]}
    />
  );
}
